// extracted by mini-css-extract-plugin
module.exports = {"tipText":"setting-form_tipText_3MsmA","row":"setting-form_row_jCeE-","btn":"setting-form_btn_2u9HU"};